export const team = [
  {
    src: "mati.webp",
    alt: "A picture of Matías Di Iorio",
    name: "Matías Di Iorio",
    role: "Founder / Head of design",
    desc: "Type designer and teacher. Master Program in Typography at FADU-UBA; teaches type and graphic design at FADU-UDELAR.",
  },
  {
    src: "fer.webp",
    alt: "A picture of Fernando Díaz",
    name: "Fernando Díaz",
    role: "Founder / Foundry operations",
    desc: "Type designer, a decade in typography. Co-directed TipoType and released over ten families used worldwide.",
  },
  {
    src: "lea.webp",
    alt: "A picture of Leandro Chelentano",
    name: "Leandro Chelentano",
    role: "Founder / Lead programmer",
    desc: "Software developer in Uruguay, years of building complex systems and working with large datasets.",
  },
  {
    src: "simon.webp",
    alt: "A picture of Simón Bertón",
    name: "Simón Bertón",
    role: "Founder / CTO",
    desc: "Senior developer focused on scalable systems and working closely with the foundries using them.",
  },
];
